import React, { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import DialogContentModal from "../components/DialogContent";
import ApplicaionFormatView from "../../Forms/ApplicationView";
import PaymentPrint from "@egovernments/digit-ui-module-obps/src/pages/employee/PaymentSlipEmpAll/payment/PaymentSlip";
import NOCFormatView from "../../Forms/NOCFormatView";
import ApplicationView12 from "../../Forms/Form12/Application12View";
// import ApplicationWorkflowDetails from "../../Forms/Form12/HistoryForms";
import ApplicationViewHistory from "../../Forms/Form12/ApplicationHistory";
import ApplicationViewHistoryAll from "../../Forms/Form12/ApplicationHistoryAll";
import TakeActionItem from "../../Forms/TakeActionItem";
import OwnerSummary from "../../Forms/ownerRegistrationSummary";
import Summary from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/formComponents/purchasableFAR/Summary";

const EmployeeComponent = ({ formData, applicationDocs, totalAmount }) => {
  let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  const [smShowNoc, setSmShowNoc] = useState(false);
  const [smShowPayment, setSmShowPayment] = useState(false);
  const [smShowMs, setSmShowMs] = useState(false);
  const [smShowMsHistory, setSmShowMsHistory] = useState(false);
  const { t } = useTranslation();
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [formHistory, setFormHistory] = useState("");

  //   const closeModal2 = (formData) => {
  //     if (formData?.oldApplicationType === "FORM_12") {
  //         setIdData(formData?.oldApplicationNo)
  //         setFormType("form12")
  //         if (formData?.oldApplicationNo != null) {
  //             setSmShowMs(true)
  //         }
  //         else {
  //             console.log("Application Number Null ");
  //         }
  //     }
  //     if (formData?.oldApplicationType === "FORM_11") {
  //         setIdData(formData?.oldApplicationNo)
  //         setFormType("form11")
  //         if (formData?.oldApplicationNo != null) {
  //             setSmShowMs(true)
  //         }
  //         else {
  //             console.log("Application Number Null ");
  //         }
  //     }
  //     else {
  //         console.log("all", formData?.oldApplicationNo);
  //     }

  //     // anchorEl(false)
  // };
  //   const closeModalHistory = (formData) => {
  //     if (formData?.oldApplicationType === "FORM_12") {
  //         setIdData(formData?.oldApplicationNo)
  //         setFormType("form12")
  //         setFormHistory("WorkHistory")
  //         if (formData?.oldApplicationNo != null) {
  //           setSmShowMsHistory(true)
  //         }
  //         else {
  //             console.log("Application Number Null ");
  //         }
  //     }
  //     if (formData?.oldApplicationType === "FORM_11") {
  //         setIdData(formData?.oldApplicationNo)
  //         setFormType("form11")
  //         if (formData?.oldApplicationNo != null) {
  //             setSmShowMs(true)
  //         }
  //         else {
  //             console.log("Application Number Null ");
  //         }
  //     }
  //     else {
  //         console.log("all", formData?.oldApplicationNo);
  //     }

  // };

  const closeModal2 = (formData) => {
    if (formData?.oldApplicationType === "FORM_12") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form12");
      if (formData?.oldApplicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_11") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form11");
      if (formData?.oldApplicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_26") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form26");
      if (formData?.oldApplicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_NOC") {
      setIdData(formData?.oldApplicationNo);
      setFormType("formNOC");
      if (formData?.oldApplicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all", formData?.oldApplicationNo);
    }

    // anchorEl(false)
  };

  const closeModalHistory = (formData) => {
    if (formData?.oldApplicationType === "FORM_12") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form12");
      setFormHistory("WorkHistory");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_11") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form11");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_26") {
      setIdData(formData?.oldApplicationNo);
      setFormType("form26");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_MT") {
      setIdData(formData?.oldApplicationNo);
      setFormType("formMT");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_NOC") {
      setIdData(formData?.oldApplicationNo);
      setFormType("formNOC");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if (formData?.oldApplicationType === "FORM_CLU") {
      setIdData(formData?.oldApplicationNo);
      setFormType("formCLU");
      if (formData?.oldApplicationNo != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all", formData?.oldApplicationNo);
    }
  };

  return (
    <React.Fragment>
      <div style={{ backgroundColor: "#eeeab5b0", padding: "10px" }}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)">
          <Box gridColumn="span 12" sx={{ ml: 2 }}>
            {formData?.applicationType !== "FORM_PURCHASABLE_FAR" && (
              <button
                className="btn btn-primary"
                style={{ padding: "4px 8px", fontSize: "14px", margin: "4px 0px 8px 0px" }}
                onClick={() => {
                  setSmShow(true), console.log("modal open");
                }}
              >
                View Application
              </button>
            )}
            {formData?.applicationType === "FORM_PURCHASABLE_FAR" && (
              <button
                className="btn btn-primary"
                style={{ padding: "4px 8px", fontSize: "14px", margin: "4px 0px 8px 0px" }}
                onClick={() => {
                  setSmShow(true), console.log("modal open");
                }}
              >
                View Application
              </button>
            )}
          </Box>
          <Box gridColumn="span 2">
            <b>{t(`BPA_APPLICATION_NUMBER_LABEL`)}</b>
          </Box>
          <Box gridColumn="span 3">: &nbsp;&nbsp;&nbsp;{formData?.applicationNo || ""}</Box>
          <Box gridColumn="span 7"></Box>

          <Box gridColumn="span 2">
            <b>Mobile Number</b>
          </Box>
          <Box gridColumn="span 10">
            {formData?.applicationType !== "FORM_NOC" && (
              <>{formData?.landInfo?.owners && formData?.landInfo?.owners?.map((ob, index) => <div>: &nbsp;&nbsp; {ob?.mobileNumber}</div>)}</>
            )}
            {formData?.applicationType === "FORM_NOC" && <> : &nbsp;&nbsp;{formData?.professionalInformation?.mobileNumber}</>}
          </Box>
          <Box gridColumn="span 2">
            <b>Applicant Name</b>
          </Box>
          <Box gridColumn="span 10">
            {formData?.applicationType !== "FORM_NOC" && (
              <>{formData?.landInfo?.owners && formData?.landInfo?.owners?.map((ob, index) => <div>: &nbsp;&nbsp;&nbsp;{ob?.name}</div>)}</>
            )}

            {formData?.applicationType === "FORM_NOC" && <> :&nbsp;&nbsp;&nbsp;{formData?.professionalInformation?.name}</>}
          </Box>
          <Box gridColumn="span 2">
            <b>Services Name</b>
          </Box>
          <Box gridColumn="span 10">
            {formData?.applicationType === "FORM_LANDUSE" && <> :&nbsp;&nbsp;&nbsp;{"Land Use Verification"}</>}
            {formData?.applicationType === "FORM_OWNER_REGISTRATION" && <> :&nbsp;&nbsp;&nbsp;{"Owner Registration"}</>}
            {formData?.applicationType === "FORM_PURCHASABLE_FAR" && <> :&nbsp;&nbsp;&nbsp;{"Purchasable FAR"}</>}

            {/* {formData?.applicationType === "FORM_NOC" && <> :&nbsp;&nbsp;&nbsp;{formData?.applicationType}</>} */}
            {/* {formData?.applicationType !== "FORM_NOC" && <> :&nbsp;&nbsp;&nbsp;{"Land Use Form"}</>} */}
          </Box>
        </Box>

        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShow}
          onClose={() => {
            setSmShow(false);
          }}
        >
          {formData?.applicationType === "FORM_OWNER_REGISTRATION" && (
            <OwnerSummary formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
          )}

          {formData?.applicationType === "FORM_LANDUSE" && (
            <ApplicaionFormatView formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
          )}
          {formData?.applicationType === "FORM_PURCHASABLE_FAR" && <Summary id={formData?.applicationNo} />}
        </DialogContentModal>

        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShowNoc}
          onClose={() => {
            setSmShowNoc(false);
          }}
        >
          <NOCFormatView formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
        </DialogContentModal>

        <DialogContentModal
          title={"Application Payment Details"}
          dataOpen={smShowPayment}
          onClose={() => {
            setSmShowPayment(false);
          }}
        >
          <PaymentPrint id={formData?.applicationNo} />
        </DialogContentModal>
        {formType === "form12" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <ApplicationView12 id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "form12" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistory id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* 11 Form */}
        {formType === "form11" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "form11" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* 26 Form */}
        {formType === "form26" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "form26" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* MT Form */}
        {formType === "formMT" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "formMT" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* NOC Form */}
        {formType === "formNOC" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "formNOC" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
        {/* CLU Form */}
        {formType === "formCLU" && (
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowMs}
            onClose={() => {
              setSmShowMs(false);
            }}
          >
            <TakeActionItem id={idData} formType={formType} />
          </DialogContentModal>
        )}
        {formType === "formCLU" && (
          <DialogContentModal
            title={"Old Application History"}
            dataOpen={smShowMsHistory}
            onClose={() => {
              setSmShowMsHistory(false);
            }}
          >
            <ApplicationViewHistoryAll id={idData} formType={formType} formHistory={formHistory} />
          </DialogContentModal>
        )}
      </div>

      {/* )} */}
    </React.Fragment>
  );
};
export default EmployeeComponent;
